import { getGlobalUserId } from "../../stempcore/src/core/client";
import comonService from "../services/comonService";
import { socketModule } from "./socket";
import { ck, interact, URLS } from "fire-wind-water";
import { $subscriber } from "fire-wind-water";
let registrationForm = "";
let device = !!navigator.userAgent.match(
  /(iPhone|iPod|Android|ios|HarmonyOS|OpenHarmony)/i
);
let loginUrl = "";
let isWeChatBrowser =
  navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1;
let device1 = "";
let returnUrl = window.location.href; //登录报名后返回地址
let tc = URLS.getURL("tc");
let customFormId = URLS.getURL("customFormId");
let isMobile = !!navigator.userAgent.match(
  /(iPhone|iPod|Android|ios|HarmonyOS|OpenHarmony)/i
);

let cookie = "";
let isLogin = false;
///去登录
function validateState(webinar, user, b) {
  //会场未发布
  if (!webinar.isReleased) {
    $subscriber.emit("showPopup", { message: "很抱歉，会场未发布" });
    return false;
  }
  if (webinar.replaySwitch === 1) {
  } else {
    //会场已关闭
    if (webinar.isClosed) {
      $subscriber.emit("showPopup", {
        message: "很抱歉，您来晚了，本场会议已经关闭"
      });
      return false;
    }
  }
  //账户冻结 //报名用户已被删除
  if (!user.hasPermission || user.isDelete) {
    if (!b) {
      if (user.permission === 2) {
        window.$sk.tips.show("您的报名信息正在审核，请等待！");
      } else if (user.permission === 0) {
        window.$sk.tips.show("很抱歉！您未通过报名审核！");
      } else {
        window.$sk.tips.show("很抱歉，您没有权限观看本次会议");
      }
    }
    return false;
  }
  //会场未开放
  if (!webinar.isOpen) {
    window.$sk.tips.show("会议暂未开始！请稍后！", {
      time: 3000, //提示框停留的时间
      callback: () => {
        if (isMobile) {
          if (webinar.signupEndWapUrl) {
            window.$sk.goto(webinar.signupEndWapUrl);
            return;
          } else {
            if (window.location.href.indexOf("meetingInfo") == -1) {
              window.$sk.goto(
                window.location.href.replace("meeting", "meetingInfo")
              );
            }
            return;
          }
        } else {
          if (webinar.signupEndPcUrl) {
            window.$sk.goto(webinar.signupEndPcUrl);
            return;
          } else {
            if (window.location.href.indexOf("meetingInfo") == -1) {
              window.$sk.goto(
                window.location.href.replace("meeting", "meetingInfo")
              );
            }
            return;
          }
        }
      } // 关闭后回调
    });
    return false;
  }
  return true;
}

function joinMett(webinar, user, callback) {
  cookie = ck.cookie("smarketMember_" + webinar.schemaId);
  isLogin = cookie !== "" && cookie != null;
  // if (cookie !== "" && cookie != null) { //上为简化版
  //   isLogin = true;
  // } else {
  //   isLogin = false;
  // }
  let href = window.location.href;
  if (webinar.isOpen) {
    returnUrl = href.replace("/meetingInfo", "/meeting");
  } else {
    if (window.location.href.indexOf("meetingInfo") > -1) {
      returnUrl = href;
    } else {
      returnUrl =
        window.location.href.substr(
          0,
          window.location.href.indexOf("/meeting")
        ) + "/meetingInfo";
    }
  }
  if (webinar.needLogin && !isLogin) {
    goToLogin(webinar, user, function() {
      if (webinar.needRegistration && !user.isRegistration) {
        //需要报名
        goToSignUp(webinar, function(registrationUrl) {
          window.$sk.goto(
            loginUrl +
              "sourceKey=" +
              URLS.getURL("sourceKey") +
              "&backUrl=" +
              encodeURIComponent(registrationUrl)
          );
        });
      } else {
        //已报名或无需报名
        window.$sk.goto(
          loginUrl +
            "sourceKey=" +
            URLS.getURL("sourceKey") +
            "&backUrl=" +
            encodeURIComponent(returnUrl)
        );
      }
    });
  } else {
    if (!user.isRegistration) {
      if (webinar.needRegistration) {
        //需要报名
        goToSignUp(webinar, function(jumpUrl) {
          window.$sk.goto(jumpUrl);
        });
      } else {
        silentSignUp(webinar, user, callback); //无限制观看（无需登录报名）
      }
    } else {
      window.$sk.goto(
        loginUrl +
          "sourceKey=" +
          URLS.getURL("sourceKey") +
          "&backUrl=" +
          encodeURIComponent(returnUrl)
      );
    }
  }
}
function onKickOut(data, webinar) {
  $subscriber.emit("showPopup", { message: data });
  socketModule.disconnect();
  if (webinar && !webinar.isOpen && webinar.isReleased) {
    if (isMobile) {
      if (webinar.signupEndWapUrl) {
        window.$sk.goto(webinar.signupEndWapUrl);
        return;
      } else {
        jumpEndUrl();
      }
    } else {
      if (webinar.signupEndPcUrl) {
        window.$sk.goto(webinar.signupEndPcUrl);
        return;
      } else {
        jumpEndUrl();
      }
    }
  } else {
    jumpEndUrl();
  }
}
function jumpEndUrl() {
  setTimeout(function() {
    if (window.location.href.indexOf("/meetingInfo") > -1) {
      window.location.reload();
    } else {
      window.$sk.goto(
        window.location.href.substr(
          0,
          window.location.href.indexOf("/meeting")
        ) + "/meetingInfo"
      );

      window.$redEnvelope.destroy();
    }
  }, 1000);
}

function logout(webinar) {
  return comonService
    .logoutWeChat({
      globalUserId: ck.cookie("globalUserId"),
      browseInfo: interact.browseInfo,
      sess: ck.cookie(`smarketMember_` + webinar.schemaId).session,
      schemaId: webinar.schemaId
    })
    .subscribe(data => {
      logoutHandler(webinar);
    });
  /*if (isWeChatBrowser) {
    return comonService
      .logoutWeChat({
        globalUserId: ck.cookie("globalUserId"),
        schemaId: webinar.schemaId
      })
      .subscribe(data => {
        console.log("微信解绑成功", data);
        logoutHandler(webinar);
      });
  }*/
}

function logoutHandler(webinar) {
  if (ck.cookie("smarketMember_" + webinar.schemaId)) {
    //如果退出需要清楚cookieid 为无限制观看做的操作
    ck.cookie("globalUserId", null, {
      domain: window.$sk.config.domain,
      path: "/"
    });

    ck.cookie("smarketMember_" + webinar.schemaId, null, {
      domain: window.$sk.config.domain,
      path: "/"
    });
  }

  if (
    ck.cookie("verify_" + webinar.weChatId) &&
    ck.cookie("verify_" + webinar.weChatId) !== ""
  ) {
    ck.cookie("verify_" + webinar.weChatId, null, {
      expires: 1 / 12,
      domain: window.$sk.config.domain,
      path: "/"
    });
    ck.cookie("verifyInfo_" + webinar.weChatId, null, {
      expires: 1 / 12,
      domain: window.$sk.config.domain,
      path: "/"
    });
  }
  if (ck.cookie("registrationMember_" + webinar.webinarId)) {
    ck.cookie("registrationMember_" + webinar.webinarId, null, {
      domain: window.$sk.config.domain,
      path: "/"
    });
  }
  if (!ck.cookie("globalUserId")) {
    getGlobalUserId(); // 生成匿名用户
  }
  socketModule.disconnect();
  if (window.location.href.indexOf("meetingInfo") > -1) {
    window.location.reload();
  } else {
    window.$sk.goto(
      window.location.href.substr(0, window.location.href.indexOf("/meeting")) +
        "/meetingInfo"
    );
  }
}

function goToLogin(webinar, user, callback) {
  comonService
    .getRegistrationForm({
      tenantId: webinar.tenantId,
      memberFormId: webinar.registrationFormId
    })
    .subscribe(data => {
      registrationForm = data.content;
      device1 = device ? "wap" : "pc";
      loginUrl = registrationForm.loginUrl
        ? registrationForm.loginUrl[device1]
        : registrationForm.originUrl[device1];
      loginUrl += loginUrl.indexOf("?") > -1 ? "&" : "?";
      if (URLS.getURL("markCode")) {
        loginUrl += "markCode=" + URLS.getURL("markCode") + "&";
      }
      if (URLS.getURL("memberFormId")) {
        loginUrl += "memberFormId=" + webinar.registrationFormId + "&";
      }
      if (isWeChatBrowser) {
        //是在微信中打开
        var weChatId = webinar.weChatId;
        if (weChatId) {
          loginUrl += "weChatId=" + weChatId + "&";
        }
      }
      callback(loginUrl);
    });
}
function goToSignUp(webinar, callback) {
  let customForm = "";
  let htmlArray = "";
  let configId = "";
  let type = device ? "mobile" : "pc";
  let queryConfigId = URLS.getURL("configId");
  let pageSearch = window.location.search + "&isWebinar=1";
  let globalUserId = ck.cookie("globalUserId");
  comonService
    .getCustomForm({
      tenantId: webinar.tenantId,
      customFormId: customFormId,
      globalUserId: globalUserId,
      __module__: 2,
      __objId__: webinar.id
    })
    .subscribe(data => {
      customForm = data.content;
      htmlArray = customForm.template[type].html;
      configId = customForm.template[type].configId;
      if (configId !== queryConfigId) {
        pageSearch = pageSearch.replace(
          "configId=" + queryConfigId,
          "configId=" + configId
        );
      }
      if (!queryConfigId) {
        pageSearch += "&configId=" + configId;
      }

      //做兼容新旧表单模板处理1
      if (customForm.templateVersion == 1) {
        var signUpHtmlIndexNew = 0,
          toTitleNew = webinar.needLogin ? "_index" : "_verify";
        for (var j = 0, m = htmlArray.length; j < m; j++) {
          if (htmlArray[j].usePage.indexOf(toTitleNew) > 0) {
            signUpHtmlIndexNew = j;
            break;
          }
        }
        if (typeof callback === "function") {
          callback(
            customForm.template[type].formalUrl +
              pageSearch +
              "&returnUrl=" +
              encodeURIComponent(returnUrl) +
              htmlArray[signUpHtmlIndexNew]["formalUrlOriginal"]
          );
        }
      } else {
        var signUpHtmlIndex = 0,
          toTitle = webinar.needLogin ? "表单页" : "身份验证页面";
        for (var i = 0, max = htmlArray.length; i < max; i++) {
          if (htmlArray[i].title == toTitle) {
            signUpHtmlIndex = i;
            break;
          }
        }
        if (typeof callback === "function") {
          callback(
            htmlArray[signUpHtmlIndex]["formalUrl"] +
              pageSearch +
              "&returnUrl=" +
              encodeURIComponent(returnUrl)
          );
        }
      }
    });
}
function silentSignUp(webinar, user, callback) {
  comonService
    .checkRegistration({
      customFormId: customFormId,
      cookieId: ck.cookie("globalUserId"),
      instanceId: webinar.instanceId,
      sess: user.cookie ? user.cookie.session : "",
      openId: user.openId || "",
      includeFormData: 1,
      tenantId: webinar.tenantId
    })
    .subscribe(data => {
      const params = {
        webinarId: webinar.id,
        moduleId: 2,
        tenantId: webinar.tenantId,
        formId: webinar.isSilent ? customFormId : 0,
        channel: tc || "",
        globalUserId: user.globalUserId,
        weChatId: webinar.weChatId || "",
        openId: webinar.unLimit ? "" : user.openId || "",
        sess: webinar.unLimit ? "" : user.cookie ? user.cookie.session : "",
        isPreview: "0",
        signUpSource: device ? "WAP" : "PC",
        isUnLimit: webinar.unLimit ? 1 : 0, //无限制观看静默报名 1 是 0 否
        // markCode 与 marketingSess 为用于统计的埋点相关参数
        markCode: URLS.getURL("markCode") || "",
        markType: URLS.getURL("markType") || "",
        marketingSess: ck.cookie("marketingSess") || ""
      };
      if (data.content.formData && data.content.formData.length > 0) {
        params.formData = data.content.formData;
      }
      comonService.silentSignUp(params).subscribe(data => {
        callback(data);
      });
    });
}

export { joinMett, onKickOut, goToSignUp, logout, goToLogin, validateState };
